import { useAnimation, useScroll, useMotionValueEvent } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain } from '@fortawesome/free-solid-svg-icons';

import { publicUrlStr } from '../../utils';
import { SearchBox, AISearch } from '../../components';
import { atomOfProfileData } from '../../global';
import * as S from './style';

const menus = [
  { name: 'video', nicName: 'Video', path: '/' },
  { name: 'image', nicName: 'Image', path: '/image' },
  { name: 'audio', nicName: 'Audio', path: '/audio' },
  { name: 'admin', nicName: 'Admin', path: '/admin' }
];

const initSelect = (pathname: string) => {
  const paths = pathname.split('/');
  const found = menus.find(menu => paths.includes(menu.name));
  return found ? found.name : menus[0].name;
}

function Header() {
  const menuAnimation = useAnimation();
  const { pathname } = useLocation();
  const { scrollY } = useScroll();
  const [selected, setSelected] = useState<string>(initSelect(pathname));
  const [aiSearchOpen, setAiSearchOpen] = useState(false);
  const profileData = useRecoilValue(atomOfProfileData);

  const isAdmin = profileData.name?.includes('Admin');
  const visibleMenus = isAdmin ? menus : menus.filter(m => m.name !== 'admin');

  useMotionValueEvent(scrollY, 'change', (getY) => {
    getY > 40 ?
      menuAnimation.start("scroll") :
      menuAnimation.start("top");
  });
  
  const onSelect = (name: string) => {
    setSelected(name);
  };

  useEffect(() => {
    const search = pathname.split('/').includes('search');
    if (search) onSelect('search');
  }, [pathname]);

  // 🐞[Bug]: layoutId Bug Issue Link : https://github.com/framer/motion/issues/1580

  return (
    <>
      <S.Nav variants={S.menuVariants} initial="top" animate={menuAnimation}>
        <S.Col>
          <S.Logo href={`${publicUrlStr()}`}>
            <img src={`${publicUrlStr()}/assets/svg/gdflix_logo.svg`} alt="gdflix logo" />
          </S.Logo>
          <S.List>
            {visibleMenus.map((menu) => (
              <S.Item className={selected === menu.name ? 'select' : ''} key={menu.name} onClick={() => onSelect(menu.name)}>
                <Link to={`${publicUrlStr()}${menu.path}`}>{menu.nicName}</Link>
                {selected === menu.name ? <S.Line layoutId="circle" /> : null}
              </S.Item>
            ))}
          </S.List>
        </S.Col>
        <S.Col>
          <S.AISearchBtn onClick={() => setAiSearchOpen(true)} title="AI 통합 검색">
            <FontAwesomeIcon icon={faBrain} />
          </S.AISearchBtn>
          <SearchBox />
          <S.ProfileBox layoutId={profileData.id ? '' : 'profile'}>
            <img src={profileData.background_path} alt="user profile icon" />
          </S.ProfileBox>
        </S.Col>
      </S.Nav>
      {aiSearchOpen && <AISearch isOpen={aiSearchOpen} onClose={() => setAiSearchOpen(false)} />}
    </>
  );
}

export default Header;

// [ useAnimation() ]
// - 코드를 통해 요소들을 제어할 때 요소들에게 동시에 애니메이션 효과를주기 위해 사용하는 방법이다.
// - 애니메이션 효과를 조건에 따라 동적으로 효과를 변경할 수 있다.

// -> https://www.framer.com/docs/animation/#component-animation-controls